/* * @Author: 曹俊杰 * @Date: 2022-05-10 18:47:09 * @Module: 出证 */
<template>
  <div class="inspiectSearch">
  <div v-html="aliform"></div>
    <div class="box">
      <div class="title">申请出证</div>
      <div class="row" style="margin-top: 20px">
        <div class="row-left">选择出证类型：</div>
        <div class="row-right paichabox">
          <div
            class="item"
            @click="form.certificateType = 0"
            :class="{ activeItem: form.certificateType === 0 }"
          >
            <div class="row1">
              <div class="row1-l">
                <c-radio :value="form.certificateType === 0" />
                <p class="tit">电子版</p>
              </div>
              <!-- <div class="row1-r">预览</div> -->
            </div>
            <div class="row2">
              可证明签署全流程有效性，包含双方签署意愿、真实身份与签署文件无篡改
            </div>
            <div class="row3">出证时间：3-7个工作日，邮箱发送</div>
            <div class="row4">
              <div class="row4-l">
                <span>出证机构：</span>
                <span>中能e签（电子章）</span>
              </div>
              <div class="row4-r">
                <span>100元 </span>
                <span>/ 合同 </span>
              </div>
            </div>
          </div>
          <div
            class="item"
            @click="form.certificateType = 1"
            :class="{ activeItem: form.certificateType === 1 }"
          >
            <div class="row1">
              <div class="row1-l">
                <c-radio :value="form.certificateType === 1" />
                <p class="tit">纸质版</p>
              </div>
              <!-- <div class="row1-r">预览</div> -->
            </div>
            <div class="row2">
              可证明签署全流程有效性，包含双方签署意愿、真实身份与签署文件无篡改
            </div>
            <div class="row3">出证时间：3-10个工作日，线下邮寄</div>
            <div class="row4">
              <div class="row4-l">
                <span>出证机构：</span>
                <span>中能e签（实体章）</span>
              </div>
              <div class="row4-r">
                <span>200元 </span>
                <span>/ 合同 </span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row" style="margin-top: 40px">
        <div class="row-left" style="line-height: 36px">申请合同信息：</div>
        <div class="row-right">
          <etable :list="contract" isIssue hindIssue style="width: 100%;"/>
        </div>
      </div>
      <div class="row" style="margin-top: 40px" v-show="form.certificateType === 1">
        <div class="row-left" style="line-height: 36px">填写收件人信息：</div>
        <div class="row-right">
          <div class="form">
            <el-form :model="form" ref="form" :rules="rules">
              <el-row :gutter="20">
                <el-col :span="8">
                  <el-form-item prop="receiptName" label="姓名">
                    <el-input
                      v-model="form.receiptName"
                      placeholder="请输入收件人姓名"
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item prop="receiptPhone" label="手机号">
                    <el-input
                      v-model="form.receiptPhone"
                      placeholder="请输入收件人手机号"
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item prop="receiptAddress" label="地址">
                    <el-input
                      v-model="form.receiptAddress"
                      placeholder="请输入收件人地址"
                    ></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-form>
          </div>
        </div>
      </div>
      <div class="row" style="margin-top: 40px" v-show="form.certificateType !== 1">
        <div class="row-left" style="line-height: 36px">收件人信息：</div>
        <div class="row-right" style="line-height: 36px; color: #666666; font-size: 14px">
          将以短信的形式通知您进行下载
        </div>
      </div>
    </div>
    <div class="btns">
      <el-button @click="$router.go(-1)">取消</el-button>
      <el-button type="primary" @click="onBuy" :disabled="disabled">提交</el-button>
    </div>
    <buy ref="buyRef" @onSubmit="sub"  />
  </div>
</template>
<script>
import cRadio from "@/components/form/cRadio.vue";
import etable from "@/views/ElectronicDocuments/etable";
import buy from "@/components/buy.vue";
export default {
  components: { cRadio, etable, buy },
  data() {
    const phoneValidator = (_, value, callback) => {
      if (this.$utils.test.mobile(value)) {
        return callback();
      } else {
        return callback(new Error("请输入正确的手机号"));
      }
    };
    return {
      second: 0,
      loading: false,
      form: {
        receiptName: "",
        receiptPhone: "",
        receiptAddress: "",
        certificateType: 0,
        paymentMethod: 1,
      },
      rules: {
        receiptName: [{ required: true, message: "请输入被查询姓名" }],
        receiptPhone: [
          { required: true, message: "请输入被查询人手机号" },
          { validator: phoneValidator, trigger: "blur" },
        ],
        receiptAddress: [{ required: true, message: "请输入被查询人地址" }],
      },
      contract: [],
      contractId: null,
      uuid: null,
      aliform: "",
    };
  },
  computed: {
    disabled() {
      if (this.form.certificateType == 1) {
        return (
          this.$utils.test.empty(this.form.receiptName) ||
          this.$utils.test.empty(this.form.receiptPhone) ||
          this.$utils.test.empty(this.form.receiptAddress)
        );
      } else {
        return false;
      }
    },
  },
  mounted() {
    const { contractId, uuid } = this.$route.query;
    if (contractId && uuid) {
      this.contractId = contractId;
      this.uuid = uuid;
      this.getContractDetail();
    }
  },
  activated() {
  const { contractId, uuid } = this.$route.query;
  if (contractId && uuid) {
    this.contractId = contractId;
    this.uuid = uuid;
    this.getContractDetail();
  }
},
  methods: {
    sub(paymentMethod) {
      this.form.paymentMethod = paymentMethod;
      if (this.form.certificateType == 1) {
        this.$refs.form.validate((valid) => {
          if (valid) {
            this.postCertificateRequest();
          } else {
            return false;
          }
        });
      } else {
        this.postCertificateRequest();
      }
    },
    onBuy() {
      let chanpinList = [];
      if (this.form.certificateType === 0) {
        chanpinList = [
          {
            name: "申请出证（电子版）",
            price:100,
          },
        ];
      }
       if (this.form.certificateType === 1) {
        chanpinList = [
          {
            name: "申请出证（纸质版）",
            price: 200,
          },
        ];
      }
      this.$refs.buyRef.show({ chanpinList });
    },
    async postCertificateRequest() {
      const { data, status, info } = await this.$api.postCertificateRequest({
        ...this.form,
        contractId: this.contractId,
      });
      if (status === 200) {
        if (this.form.paymentMethod == 2 ) {
            this.aliform = data;
            this.$nextTick(() => {
              const forms = Array.from(document.forms);
              const alipayForm = forms.find((form) =>
                form.action.includes("alipay.com/gateway.do")
              );
              if (alipayForm) {
                alipayForm.submit();
              } else {
                console.warn("找不到支付宝表单");
              }
              // document.forms[0].submit(); //重点--这个才是跳转页面的核心,获取第一个表单并提交
            });
            return;
          }
        this.$message({
          message: info,
          type: "success",
        });
        this.$refs.buyRef.close();
        this.$router.go(-1);
      } else {
        this.$message({
          message: info,
          type: "error",
        });
      }
    },
    // 获取合同信息
    async getContractDetail() {
      const { status, data } = await this.$api.getContractDetail({
        contractId: this.contractId,
      });
      console.log(data);
      if (status === 200) {
        this.contract = [data];
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.inspiectSearch {
  .box {
    background: #fff;
    border-radius: 6px;
    padding-bottom: 40px;

    .title {
      height: 60px;
      line-height: 60px;
      font-family: "Noto Sans SC";
      font-size: 16px;
      font-style: normal;
      font-weight: 500;
      padding: 0 20px;
    }

    .row {
      display: flex;
      gap: 14px;
      .row-left {
        width: 162px;
        text-align: right;
        font-family: "Noto Sans SC";
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
        flex-shrink: 0
      }

      .row-right {
        width: 100%;
        padding-right: 50px;
        .form {
          @include formStyle;
        }
        .item {
          width: 340px;
          height: 180px;
          border-radius: 4px;
          border: 1px solid #eee;
          background: linear-gradient(90deg, #fff 0%, #f8f8f8 100%);
          padding: 20px;
          cursor: pointer;
          .row1 {
            display: flex;
            height: 22px;
            justify-content: space-between;

            &-l {
              display: flex;
              align-items: center;

              .tit {
                margin-left: 8px;
                font-family: "Noto Sans SC";
                font-size: 16px;
                font-style: normal;
                font-weight: 500;
                line-height: normal;
              }
            }

            &-r {
              color: #0062ff;
              font-family: "Noto Sans SC";
              font-size: 14px;
              font-style: normal;
              font-weight: 400;
              line-height: normal;
            }
          }

          .row2 {
            font-family: "Noto Sans SC";
            font-size: 13px;
            font-style: normal;
            font-weight: 400;
            line-height: 22px;
            /* 169.231% */
            margin-top: 8px;
          }

          .row3 {
            color: #666;
            font-family: "Noto Sans SC";
            font-size: 12px;
            font-style: normal;
            font-weight: 400;
            line-height: normal;
            margin-top: 8px;
          }

          .row4 {
            display: flex;
            justify-content: space-between;
            font-size: 13px;
            margin-top: 17px;
            color: #666;

            &-l {
              :last-child {
                color: #262626;
              }
            }

            &-r {
              :first-child {
                color: #ff0d0d;
              }
            }
          }
        }

        .activeItem {
          border: 1.5px solid #1f5aec;

          background: #eff6ff;
        }
      }

      .paichabox {
        display: flex;

        .item:nth-child(3n - 1) {
          margin: 0 20px;
        }
      }
    }

    .button {
      width: 110px;
      height: 40px;
    }
  }
  .btns {
    height: 66px;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    margin-top: 16px;
    padding: 0 16px;
    border-radius: 4px;
    background: #ffffff;
  }
}
</style>
